import React, { useState, useEffect } from 'react'
import { Fill } from '@wordpress/components';
import { addFilter } from "@wordpress/hooks";
import Pagination from '../../common/Pagination';

const getPageFromPath = (path) => {
    const pageRegex = /\/page\/(\d+)$/;
    const match = path.match(pageRegex);
    return match ? Number(match[1]) : 1;
};

const AfterOrderItems = () => {
    const [orderItems, setOrderItems] = useState([]);
    const [licenseData, setLicenseData] = useState([]);
    const [totalPage, setTotalPage] = useState(1);
    const [page, setPage] = useState(1);
    const [postPerPage, setPostPerPage] = useState(10);

     const extractPageFromHash = () => {
        const hash = window.location.hash.replace("#", "");
        const [, pagePath] = hash.split("/page/");
        const currentPage = getPageFromPath(hash);
        return currentPage;
    };

     useEffect(() => {
        const handleHashChange = () => {
            const currentPage = extractPageFromHash();
            setPage(currentPage);
        };

        window.addEventListener("hashchange", handleHashChange);
        handleHashChange();

        return () => window.removeEventListener("hashchange", handleHashChange);
    }, []);

    useEffect(() => {
        addFilter(
			'easycommerce.dashboard.order_data',
			'easycommerce-license/order-data',
			(items) => {
				setOrderItems(items);
				return items;
			}
		)
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${EASYCOMMERCE.rest_base}/licenses?page=${page}&per_page=${postPerPage}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'X-WP-Nonce': EASYCOMMERCE.nonce,
                    },
                });
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const result = await response.json();
                setLicenseData(result.data.licenses || []);
                setTotalPage(result.data.total_pages || 1);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData();
    }, [page, postPerPage]);

    return (
        <>
            {orderItems && orderItems.items && orderItems.items.map((order, index) => (
                <Fill name={`easycommerce-customer-dashboard/after-order-item_${index}`} key={index}>
                    {({ item, order_id }) => {
                        const orderItem = item && orderItems && Array.isArray(orderItems.items)
                            ? orderItems.items.find(i => i.id === item.id)
                            : null;

                        const license = licenseData.find(
                            l => l.order_id == String(order_id) && l.product_id == String(item.product.id) && l.price_id == String(item.price_id)
                        );

                        return (
                            <div>
                                <span className="font-inter block font-medium text-base leading-[26px] text-ec-body">
                                    License Information
                                </span>
                                <div className="font-inter text-sm text-ec-body">
                                    <span className="font-inter font-normal text-sm leading-4 text-ec-placeholder">License Key:</span> {license ? license.license_key : 'N/A'} <br />

                                    <span className="font-inter font-normal text-sm leading-4 text-ec-placeholder">Activation Limit:</span> {license ? license.activation_limit : 'N/A'} <br />

                                    <span className="font-inter font-normal text-sm leading-4 text-ec-placeholder">Expiry:</span> {license ? (license.is_lifetime ? 'Lifetime' : license.expiry) : 'N/A'} <br />
                                </div>
                            </div>
                        )
                    }}
                </Fill>
            ))}
            {totalPage > 1 && (
                <Pagination
                    baseSlug="licenses"
                    current={page}
                    total={totalPage}
                />
            )}
        </>
    )
}

export default AfterOrderItems;